import { SxProps, Theme } from "@mui/material";

export const eyebrowSx: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: "0.7rem",
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "#38bdf8",
  mb: 2,
};

export const gradientTextSx: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 55%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const ceoSpotlightContainer: SxProps<Theme> = {
  flex: "0 0 55%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  px: { xs: 4, md: 10, lg: 14 },
  py: { xs: 8, md: 14 },
};

export const ceoName: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 800,
  fontSize: { xs: "3rem", md: "4.5rem", lg: "5.5rem" },
  color: "white",
  letterSpacing: "-0.03em",
  lineHeight: 1,
};

export const ceoTitle: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: "0.7rem",
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: "#38bdf8",
  mt: 2,
};

export const ceoDivider: SxProps<Theme> = {
  width: "64px",
  height: "3px",
  background: "linear-gradient(90deg, #3b82f6, #38bdf8)",
  borderRadius: 2,
  my: 4,
};

export const ceoBio: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  color: "rgba(255,255,255,0.7)",
  fontSize: "1.05rem",
  lineHeight: 1.8,
  maxWidth: 480,
};

export const ceoImageContainer: SxProps<Theme> = {
  flex: "0 0 45%",
  position: "relative",
  overflow: "hidden",
  minHeight: { xs: "320px", md: "560px" },
};

export const ceoImage: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center top",
};

export const ceoImageAccent: SxProps<Theme> = {
  position: "absolute",
  left: 0,
  top: 0,
  bottom: 0,
  width: "1px",
  background:
    "linear-gradient(to bottom, transparent, rgba(56,189,248,0.4) 25%, rgba(56,189,248,0.4) 75%, transparent)",
};

export const ceoImageCorner: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  right: 0,
  width: "120px",
  height: "120px",
  background: "radial-gradient(circle at 100% 0%, rgba(56,189,248,0.12) 0%, transparent 70%)",
};

export const leaderImageContainer: SxProps<Theme> = {
  flex: "0 0 50%",
  position: "relative",
  overflow: "hidden",
  minHeight: { xs: "280px", md: "unset" },
};

export const leaderPlaceholderBg: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "radial-gradient(ellipse 60% 60% at 50% 50%, rgba(56,189,248,0.1) 0%, transparent 70%)",
};

export const leaderPlaceholderInitials: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 800,
  fontSize: "clamp(3rem, 6vw, 5rem)",
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 55%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  position: "relative",
  zIndex: 1,
  lineHeight: 1,
};

export const leaderName: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 800,
  fontSize: { xs: "1.8rem", md: "2.4rem", lg: "2.8rem" },
  color: "white",
  letterSpacing: "-0.02em",
  lineHeight: 1.1,
  mb: 1.5,
};

export const leaderTitle: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: "0.75rem",
  letterSpacing: "0.15em",
  textTransform: "uppercase",
  color: "#38bdf8",
  mb: 2,
};

export const leaderDivider: SxProps<Theme> = {
  width: "48px",
  height: "2px",
  background: "linear-gradient(90deg, #3b82f6, #38bdf8)",
  borderRadius: 1,
  mb: 3,
};

export const leaderBio: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: "0.95rem",
  color: "rgba(255,255,255,0.6)",
  lineHeight: 1.75,
};

export const directorCardImageContainer: SxProps<Theme> = {
  aspectRatio: "1",
  width: "100%",
  background: "linear-gradient(135deg, #0a1628 0%, #0d2040 60%, #081830 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  overflow: "hidden",
};

export const directorCardImage: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center top",
};

export const directorPlaceholderBg: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "radial-gradient(ellipse 60% 60% at 50% 50%, rgba(56,189,248,0.08) 0%, transparent 70%)",
};

export const directorPlaceholderAvatar: SxProps<Theme> = {
  width: 80,
  height: 80,
  borderRadius: "50%",
  background: "rgba(56,189,248,0.08)",
  border: "2px solid rgba(56,189,248,0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  zIndex: 1,
};

export const directorPlaceholderInitials: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 700,
  fontSize: "1.4rem",
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 55%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  lineHeight: 1,
};

export const directorCardName: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 700,
  color: "white",
  fontSize: "1.05rem",
  lineHeight: 1.3,
  mb: 1,
};

export const directorCardTitle: SxProps<Theme> = {
  color: "#38bdf8",
  fontFamily: "'Barlow'",
  fontSize: "0.65rem",
  textTransform: "uppercase",
  letterSpacing: "0.14em",
};

export const directorCardDivider: SxProps<Theme> = {
  width: "32px",
  height: "1px",
  background: "rgba(56,189,248,0.4)",
  mx: "auto",
  mt: 2,
};

export const valueCardNumber: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: "0.65rem",
  color: "#38bdf8",
  opacity: 0.6,
  letterSpacing: "0.1em",
  mb: 1,
};

export const valueCardLabel: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 600,
  fontSize: "0.9rem",
  color: "white",
};

export const valueCardGlowTopLeft: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "70%",
  height: "70%",
  background: "radial-gradient(ellipse at top left, rgba(56,189,248,0.18) 0%, transparent 70%)",
  pointerEvents: "none",
};

export const valueCardGlowBottomRight: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  right: 0,
  width: "60%",
  height: "60%",
  background: "radial-gradient(ellipse at bottom right, rgba(56,189,248,0.10) 0%, transparent 70%)",
  pointerEvents: "none",
};

export const missionSectionBgImage: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  backgroundImage: "url('/img/assets/MissionVisionValues.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

export const missionSectionOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "rgba(4,9,34,0.55)",
  pointerEvents: "none",
};

export const missionSectionTopGradient: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "160px",
  background: "linear-gradient(to bottom, #040922 0%, transparent 100%)",
  pointerEvents: "none",
};

export const missionSectionBottomGradient: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "160px",
  background: "linear-gradient(to top, #040922 0%, transparent 100%)",
  pointerEvents: "none",
};

export const visionMissionDividerLine: SxProps<Theme> = {
  height: "2px",
  background: "linear-gradient(90deg, #3b82f6, #38bdf8, transparent)",
  width: "100%",
  mb: 3,
};

export const visionMissionHeading: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "2.8rem" },
  color: "white",
  lineHeight: 1.1,
};

export const visionMissionBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1rem", md: "1.15rem" },
  color: "rgba(255,255,255,0.7)",
  lineHeight: 1.8,
  fontWeight: 300,
};

export const verticalDivider: SxProps<Theme> = {
  display: { xs: "none", md: "block" },
  width: "1px",
  background: "rgba(56,189,248,0.15)",
  alignSelf: "stretch",
  mx: 0,
};

export const valuesHeadingLine: SxProps<Theme> = {
  height: "2px",
  background: "linear-gradient(90deg, transparent, #3b82f6, #38bdf8, transparent)",
  width: "160px",
  mx: "auto",
  mb: 2,
};

export const valuesSubtext: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: "0.9rem",
  color: "rgba(255,255,255,0.5)",
};

export const valuesGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr 1fr 1fr", md: "repeat(5, 1fr)" },
  gap: { xs: 2, md: 2.5 },
};

export const cultureEyebrow: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: { xs: "0.85rem", md: "0.9rem" },
  color: "#38bdf8",
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  mb: 2,
};

export const cultureHeading: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "3rem" },
  color: "white",
  letterSpacing: "-0.02em",
  lineHeight: 1.1,
  mb: 5,
};

export const joinButton: SxProps<Theme> = {
  display: "inline-block",
  px: { xs: 4, md: 5 },
  py: { xs: 1.75, md: 2 },
  background: "linear-gradient(90deg, #f97316, #fb923c)",
  color: "white",
  fontFamily: "'Poppins'",
  fontWeight: 600,
  fontSize: "1rem",
  borderRadius: "9999px",
  textDecoration: "none",
  letterSpacing: "0.01em",
  "&:hover": {
    background: "linear-gradient(90deg, #ea6c0a, #f97316)",
    color: "white",
  },
};

export const heroSection: SxProps<Theme> = {
  minHeight: "100vh",
  background: "#040922",
  position: "relative",
  display: "flex",
  alignItems: "center",
  overflow: "hidden",
};

export const heroBgImage: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  backgroundImage: "url('/img/assets/PowurHQ.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

export const heroOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background:
    "linear-gradient(to left, rgba(4,9,34,0.96) 0%, rgba(4,9,34,0.82) 45%, rgba(4,9,34,0.3) 75%, rgba(4,9,34,0.08) 100%)",
  pointerEvents: "none",
};

export const heroHeading: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 800,
  fontSize: { xs: "2.5rem", md: "4rem", lg: "5rem" },
  color: "white",
  letterSpacing: "-0.03em",
  lineHeight: 1.1,
  mb: 3,
};

export const heroGradientText: SxProps<Theme> = {
  background: "linear-gradient(90deg, #3b82f6 0%, #38bdf8 55%, #67e8f9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const heroSubtitle: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: { xs: "1.1rem", md: "1.35rem" },
  color: "#38bdf8",
  fontWeight: 500,
  mb: 4,
  letterSpacing: "0.01em",
};

export const heroDescription: SxProps<Theme> = {
  fontFamily: "'Barlow'",
  fontSize: { xs: "1rem", md: "1.1rem" },
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.75,
  maxWidth: 520,
};

export const heroBottomGradient: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "180px",
  background: "linear-gradient(to bottom, transparent 0%, #040922 100%)",
  pointerEvents: "none",
};

export const leadershipHeading: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "3rem" },
  color: "white",
  letterSpacing: "-0.02em",
};

export const directorsHeading: SxProps<Theme> = {
  fontFamily: "'Poppins'",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "3rem" },
  color: "white",
  letterSpacing: "-0.02em",
  mb: 8,
};
